<div class="wrapper">
    <app-dialog-title
        class="header"
        [title]="('pages.services-state.dialogs.manual-status-change-dialog.title'| translate) + ' ' + serviceName"
        (close)="close()"
    ></app-dialog-title>
    
    <mat-dialog-content>
        <section class="content" [formGroup]="manualStatusChangeForm">
            <p class="description">
                {{ 'pages.services-state.dialogs.manual-status-change-dialog.description' | translate }}
            </p>
            <div class="status-select">
                <div class="status-select-wrapper">
                    <app-bciti-text-select 
                        [label]="'pages.services-state.dialogs.manual-status-change-dialog.status-label' | translate"
                        [placeholder]="'pages.services-state.dialogs.manual-status-change-dialog.status-placeholder' | translate"
                        [options]="statusList"
                        formControlName="status">
                    <app-form-error *ngIf="statusControl.touched && statusControl.hasError('required')">
                        {{ 'pages.services-state.dialogs.manual-status-change-dialog.errors.invalidStatus' | translate }}
                    </app-form-error>
                </app-bciti-text-select>
                </div>
            </div>

            <div class="section-translations" formGroupName="reason">
                <div class="translation-inputs" [class.full-width]="langs?.length === 1 ">
                  <div *ngFor="let lang of langs" class="lang-input-wrapper" >
                    <app-form-input 
                      type="text"
                      placeholder="{{ 'pages.services-state.dialogs.manual-status-change-dialog.reason-placeholder' | translate }}"
                      [class.error]="hasError(lang)"
                      [charLimit]="characterLimit"
                      [label]="('pages.services-state.dialogs.manual-status-change-dialog.reason-label' | translate) + ' ' + ('common.langsAbbr.' + lang | translate)"
                      [formControlName]="lang"
                    >
                    <app-form-error *ngIf="hasRequiredError(lang)">
                      {{ 'pages.services-state.dialogs.manual-status-change-dialog.errors.reasonRequired' | translate }}
                    </app-form-error>
                  </app-form-input>
                  </div>
                </div>
              </div>

            <p class="description">
                {{ 'pages.services-state.dialogs.manual-status-change-dialog.information-status' | translate }}
            </p>

            <div class="section-schedule">
                <div class="schedule-select-wrapper">
                    <app-bciti-text-select 
                        [label]="'pages.services-state.dialogs.manual-status-change-dialog.select-override-type' | translate"
                        [placeholder]="'pages.services-state.dialogs.manual-status-change-dialog.select-override-placeholder' | translate"
                        [options]="scheduleOptionList"
                        formControlName="override">
                    <app-form-error *ngIf="overrideControl.touched && overrideControl.hasError('required')">
                        {{ 'pages.services-state.dialogs.manual-status-change-dialog.errors.invalidOverrideType' | translate }}
                    </app-form-error>
                </app-bciti-text-select>
                </div>
                <div class="schedule-time-wrapper">
                    <app-form-datepicker 
                        [label]="'pages.services-state.dialogs.manual-status-change-dialog.date-label' | translate"
                        formControlName="date"
                        [large]="true"
                        [min]="startDateMin"
                        [disabled]="disableDateAndHour"
                        (change)="dateChange($event)">
                        <app-form-error *ngIf="timeControl.touched && timeControl.hasError('required')">
                            {{ 'pages.services-state.dialogs.manual-status-change-dialog.errors.requiredDate' | translate }}
                        </app-form-error>
                    </app-form-datepicker>
                    <app-bciti-time-input
                        [label]="'pages.services-state.dialogs.manual-status-change-dialog.hour-label' | translate"
                        [disabled]="disableDateAndHour"
                        formControlName="time">
                        <app-form-error *ngIf="timeControl.touched && timeControl.hasError('required')">
                            {{ 'pages.services-state.dialogs.manual-status-change-dialog.errors.requiredTime' | translate }}
                        </app-form-error>
                    </app-bciti-time-input>
                </div>
            </div>

        </section>
        

    </mat-dialog-content>

    <mat-dialog-actions>
        <button 
            class="bciti-button" 
            [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--red'"
            [disabled]="processingSubmit"
            (click)="cancel()"
        >
            <span>{{ 'common.cancel' | translate }}</span>
        </button>
        <button 
            class="bciti-button ml-10" 
            [ngClass]="processingSubmit ? 'bciti-button--disabled' : 'bciti-button--blue'"
            [disabled]="processingSubmit"
            (click)="submit()"
        >
            <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
            <span> {{ 'common.confirm' | translate }} </span>
        </button>
    </mat-dialog-actions>
</div>
